import React from "react";
import { FaStar } from "react-icons/fa";

const BusinessFeatureSection = () => {
  return (
    <section className="relative overflow-hidden bg-gradient-to-r from-dry via-reddark to-redlight py-16 sm:py-4 px-6 md:px-12">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
        {/* Left Content */}
        <div>
          <h1 className="text-4xl sm:text-5xl font-bold text-text mb-6">
            Lokalai for Business
          </h1>
          <p className="text-lg text-textGray mb-6 max-w-xl">
            Leveraging Artificial Intelligence for local businesses
            <br />
          </p>
          <a
            href="https://business.lokalai.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-redlight text-white px-6 py-3 rounded-full font-medium hover:bg-gray-800"
          >
            Find out more
          </a>

          {/* Review Section */}
          <div className="mt-10">
            <p className="text-lg font-semibold text-text">Excellent 5/5</p>
            <div className="flex items-center gap-1 text-redlight mt-1">
              {Array(5)
                .fill()
                .map((_, i) => (
                  <FaStar key={i} />
                ))}
            </div>
            <p className="text-sm text-textGray mt-1">Over 1250 reviews</p>
          </div>
        </div>

        {/* Right Side Images */}
        <div className="relative">
          {/* Calendar Image – make it fill the container and remove fixed width */}
          <img
            src="/businessfeature/dashboard.png"
            alt="Calendar"
            className="w-full h-auto rounded-xl border border-border shadow-md"
          />

          {/* Mobile Booking Image – smaller and positioned cleanly inside */}
          <img
            src="/businessfeature/bebaumobile.png"
            alt="Mobile Booking"
            className="absolute -bottom-[200px] left-[20px] w-28 sm:w-40 md:w-48 rounded-xl border border-textGray shadow-xl bg-dry"
          />
        </div>
      </div>
    </section>
  );
};

export default BusinessFeatureSection;
